/// <reference path="../../../../../../typings/index.d.ts" />
module Meevo.Plugins.RatingsControlPanel {

    export class RatingsActionsBoxController implements ng.IComponentController {
        public selectedCount: number;
        public publishSelected: () => void;
        public unpublishSelected: () => void;
        public exportCsv: () => void;
        public displayType: DisplayRatingTypesEnum;
        public viewType: DataListViewTypesEnum;

        public securityKeys = Meevo.Components.Common.SecurityKeys;
        public securityParts = Meevo.Components.Common.SecurityParts;

        get isPublished(): boolean {
            return this.displayType === DisplayRatingTypesEnum.Published;
        }

        get isUnpublished(): boolean {
            return this.displayType === DisplayRatingTypesEnum.Unpublished;
        }

        get isDetailed(): boolean {
            return this.viewType === DataListViewTypesEnum.Detailed;
        }
    }

    angular.module('meevo.plugins.ratingsControlPanel')
        .component('meevoRatingsActionsBoxComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/ratingsControlPanel/components/actionsBox/ratings-actions-box.template.html',
            controller: RatingsActionsBoxController,
            controllerAs: '$ctrl',
            bindings: {
                ratingsCount: '<',
                selectedCount: '<',
                displayType: '<',
                viewType: '<',
                publishSelected: '&',
                unpublishSelected: '&',
                exportCsv: '&',
            }
        });
}
